const e = {
  Credit: "CREDIT",
  Debit: "DEBIT",
  All: "ALL",
  Expire: "EXPIRE"
};
function i(r) {
  return n(r);
}
function n(r, t) {
  return r;
}
function o(r) {
  return r;
}
export {
  e as EntryType,
  i as EntryTypeFromJSON,
  n as EntryTypeFromJSONTyped,
  o as EntryTypeToJSON
};
//# sourceMappingURL=EntryType.js.map
